<ul nz-menu>
  @if (item.active) {
    <li nz-menu-item (click)="click($event, 'refresh')" data-type="refresh" [innerHTML]="i18n.refresh"></li>
  }
  <li
    nz-menu-item
    (click)="click($event, 'close')"
    data-type="close"
    [nzDisabled]="!item.closable"
    [innerHTML]="i18n.close"
  ></li>
  <li nz-menu-item (click)="click($event, 'closeOther')" data-type="closeOther" [innerHTML]="i18n.closeOther"></li>
  <li
    nz-menu-item
    (click)="click($event, 'closeRight')"
    data-type="closeRight"
    [nzDisabled]="item.last"
    [innerHTML]="i18n.closeRight"
  ></li>
  @if (customContextMenu!.length > 0) {
    <li nz-menu-divider></li>
    @for (i of customContextMenu; track $index) {
      <li
        nz-menu-item
        [attr.data-type]="i.id"
        [nzDisabled]="isDisabled(i)"
        (click)="click($event, 'custom', i)"
        [innerHTML]="i.title"
      ></li>
    }
  }
</ul>
